'use client';

import dynamic from 'next/dynamic';
import * as colorWheelLottieData from '@/assets/lotties/colorWheel.json';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const ColorWheelLottie = () => {
  return (
    <div className='w-[250px] lg:w-[200px]'>
      <Lottie animationData={colorWheelLottieData} width={400} loop />
    </div>
  );
};
